









































import { Component, Prop, Provide, Vue } from 'vue-property-decorator'
import { USER_GROUPS } from '../../../service/constant'
import {
  apiBatchConfirmContentModify,
  getTaskList,
  taskListColumns
} from '../../../service/platform'
import { getUrlParams } from '../../../utils/urlUtils'
import { Level1Task } from '../types/task'
import { ALL_GROUPS } from '@/config/'

@Component
export default class MyTaskList extends Vue {
  public taskListColumns: any[] = taskListColumns
  public taskList: Level1Task[] = []
  public pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    showTotal: (total, range) => `共${total}条`
  }
  private isUploader = false

  private get groups() {
    return this.$store.state[USER_GROUPS]
  }

  public async created() {
    // 默认的首页，视情况来判断路由的情况，如果是带着登陆动作，则在登陆之后来进行首页跳转。其他情况在router钩子里进行首页跳转

    let ticket = getUrlParams().ticket
    if (ticket) return // block所有网络请求
    if (!this.$store.state[USER_GROUPS] || this.$store.state[USER_GROUPS].length == 0) return // 无效账户stop

    this.getDataList(1)
  }

  mounted() {
    this.isUploader = this.groups.includes(ALL_GROUPS[4].id)
  }

  private async getDataList(pageNum) {
    const list = await getTaskList(pageNum, this.pagination.pageSize)
    const { count, current_page, data } = list

    this.taskList = data
    this.pagination.total = count
    this.pagination.current = current_page
  }

  private handlePaginationChange(pagination) {
    this.getDataList(pagination.current)
  }

  private get showBatchPass() {
    // 是否属于内容修改组
    return (this.$store.state.perm_groups || []).includes('UG_001000000020640')
  }

  private clickBatchPass() {
    this.$confirm({
      title: '批量修改完成',
      content: '是否需要批量完成所有修改任务？',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        apiBatchConfirmContentModify().then(() => {
          // @ts-ignore
          this.$message.success('批量修改完成成功')
          this.getDataList(1)
        })
      }
    })
  }
}
